import { useCallback, useMemo } from 'react';
import useRoute from '~/hooks/useRoute';
import useRouter from '~/hooks/useRouter';
import { SEARCH_DEFAULT_ROWS_PER_PAGE } from '~/scripts/constants';

export default function useReportPagination(start: string | undefined) {
  const route = useRoute();
  const router = useRouter();

  const pageNumber = useMemo(() => {
    return Math.floor(start ? +start / SEARCH_DEFAULT_ROWS_PER_PAGE : 0) + 1;
  }, [start]);

  const handlePageChange = useCallback(
    (pageNumber: number) => {
      const start = (pageNumber - 1) * SEARCH_DEFAULT_ROWS_PER_PAGE;
      router.push({
        path: route.path,
        query: {
          ...route.query,
          start: start ? start : undefined,
        },
      });
    },
    [route.path, route.query, router]
  );

  return {
    pageNumber,
    handlePageChange,
  };
}
